import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from "../network/Configurations";
import { Any } from "react-spring";

const addNotification = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.ADD_NOTIFICATION, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const sendNotifications = (request: any, params: Any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.SEND_NOTIFICATION, request, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

export const NotificationService = {
  addNotification,
  sendNotifications,
};
